export default __webpack_public_path__ + "static/media/team65.4921e2b7.JPG";